<template lang="pug">
.collect-coupons-container
  .bkg
    .safe-area(v-if="isEasyBikeApp")
    .header
      .back(@click="back")
  .content
    .free(v-if="freeOneList.length>0")
      img.free-logo(src="https://m.hellobike.com/resource/helloyun/12399/0cAI4U1tIW.png")
      div(:class="freeOneList.length>3?'scroll-container-one':'container-one'")
        .coupon-one(
          v-for="(item,index) in freeOneList"
          :key="index"
          :style="getCurrentDistance(freeOneList, index)"
        )
          div(
            :class="item.status === 1?'instant-get':'go-use'"
          )
            .business
              img.business-icon(:src="item.businessIcon")
              .business-name {{item.businessName}}
            .business-content
              .num-v1(v-if="item.couponType !== 2") {{item.worth}}
              .num-v2(v-else)
                .before {{beforeDiscount(item.discount)}}
                .after(v-if="isFloat(item.discount)") {{afterDiscount(item.discount)}}
              .unit {{item.couponType === 2 ? '折':'元'}}
            .rule
              .info(v-if="item.couponType === 3") 满{{item.couponThreshold}}元可用
              .info(v-else-if="item.couponType === 2") 最高可抵{{item.maxDiscountAmount}}元
              .info(v-else) 无门槛
            .free-btn(@click="getCoupon(item)")
      div(:class="isTwoScroll?'scroll-container-two':'container-two'")
        .coupon-two(
          v-for="(item,index) in freeTwoList"
          :key="index"
          :style="getCurrentDistance(freeTwoList, index)"
        )
          div(
            :class="item.status === 1?'instant-get':'go-use'"
          )
            .business
              img.business-icon(:src="item.businessIcon")
              .business-name {{item.businessName}}
            .business-content
              .num-v1(v-if="item.couponType !== 2") {{item.worth}}
              .num-v2(v-else)
                .before {{beforeDiscount(item.discount)}}
                .after(v-if="isFloat(item.discount)") {{afterDiscount(item.discount)}}
              .unit {{item.couponType === 2 ? '折':'元'}}
            .rule
              .info(v-if="item.couponType === 3") 满{{item.couponThreshold}}元可用
              .info(v-else-if="item.couponType === 2") 最高可抵{{item.maxDiscountAmount}}元
              .info(v-else) 无门槛
            .free-btn(@click="getCoupon(item)")
    .share(v-if="shareList.length>0")
      img.share-logo(src="https://m.hellobike.com/resource/helloyun/12399/pZhw_2KKpK.png")
      .share-card
        .share-item(
          v-for="(item,index) in shareList"
          :key="index"
          @click="goShare(item)"
        )
          img.share-coupon(:src="item.imgUrl")
    .timeout(v-if="timeoutList.length>0")
      img.timeout-logo(src="https://m.hellobike.com/resource/helloyun/12399/uwaJL5xefm.png")
      .timeout-card
        .timeout-item(
          v-for="(item,index) in timeoutList"
          :key="index"
          :style="parseInt(index + 1)%2 !== 0?'marginRight: 0.07rem':''"
          @click="goLimitTime(item)"
        )
          img.timeout-coupon(:src="item.imgUrl")
    .more(v-if="morePages.length>0")
      img.more-logo(src="https://m.hellobike.com/resource/helloyun/12399/U6BOQ_j48k.png")
      .scroll-container
        .stage(
          v-for="(item,index) in morePages"
          :key="index"
          :style="getDistance(morePages, index, 0.08)"
          @click="goPage(item)"
        )
          img.more-stage(:src="item.imgUrl")
</template>

<script>
import { Native, env } from '@hb/NBridge/lib/h5';
import Toast from '@/components/toast';
import { collectCoupons, prizeAward } from '@/api/collect-coupons';
import { getSystemCode, getVersion } from '@/utils/systemCode';
import { isPreRender, getTokenAndLocation } from '../../utils';
import { UBTUtils } from '../../utils/ubt';
import { ParamsUtil } from '../../utils/params';


export default {
  data() {
    return {
      freeOneList: [],
      freeTwoList: [],
      shareList: [],
      timeoutList: [],
      morePages: [],
    };
  },
  computed: {
    isEasyBikeApp() {
      if (env.isEasyBikeApp) {
        return true;
      }
      return false;
    },
    isTwoScroll() {
      const sum = this.freeTwoList.length + this.freeOneList.length;
      if (this.freeTwoList.length > 3
      || sum === 7) {
        return true;
      }
      return false;
    },
  },
  async mounted() {
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
    } else {
      await this.getColletList();
    }
    // 页面曝光
    UBTUtils.pageView({
      pageId: 'platform_Cross_coupon_page',
      categoryId: 'platform',
      businessInfo: {
        adsource: ParamsUtil.getParams(window.location.href).pageSrc,
      },
    });
  },
  beforeDestroy() {
    // 离开页面
    UBTUtils.pageViewOut({
      pageId: 'platform_Cross_coupon_page',
      categoryId: 'platform',
      businessInfo: {
        adsource: ParamsUtil.getParams(window.location.href).pageSrc,
      },
    });
  },
  methods: {
    back() {
      if (env.isEasyBikeApp) {
        Native.goBack();
      } else {
        this.$router.go(-1);
      }
    },
    async getColletList() {
      const data = await getTokenAndLocation();
      const {
        token, adCode, cityCode, longitude: lng, latitude: lat,
      } = data;
      const parmas = {
        token,
        adCode,
        cityCode,
        lng,
        lat,
        systemCode: getSystemCode(),
        version: await getVersion(),
        pageSrc: ParamsUtil.getParams(window.location.href).pageSrc,
      };
      try {
        const res = await collectCoupons(parmas);
        if (res.data) {
          if (res.data.firstFloorPrizes && res.data.firstFloorPrizes.length > 0) {
            this.freeOneList = res.data.firstFloorPrizes;
          } else {
            this.freeOneList = [];
          }
          if (res.data.secondFloorPrizes && res.data.secondFloorPrizes.length > 0) {
            this.freeTwoList = res.data.secondFloorPrizes;
          } else {
            this.freeTwoList = [];
          }
          if (res.data.sharePrizes && res.data.sharePrizes.length > 0) {
            this.shareList = res.data.sharePrizes;
            UBTUtils.moduleExpose({
              pageId: 'platform_Cross_coupon_page',
              categoryId: 'platform',
              moduleId: 'platform_coupon_share',
              contentId: 'platform_coupon_share',
              exposureTimes: 1,
              businessInfo: {},
            });
          } else {
            this.shareList = [];
          }
          if (res.data.limitTimePrizes && res.data.limitTimePrizes.length > 0) {
            this.timeoutList = res.data.limitTimePrizes;
            UBTUtils.moduleExpose({
              pageId: 'platform_Cross_coupon_page',
              categoryId: 'platform',
              moduleId: 'platform_coupon_Limit',
              contentId: 'platform_coupon_Limit',
              exposureTimes: 1,
              businessInfo: {},
            });
          } else {
            this.timeoutList = [];
          }
          if (res.data.morePrizes && res.data.morePrizes.length > 0) {
            this.morePages = res.data.morePrizes;
            UBTUtils.moduleExpose({
              pageId: 'platform_Cross_coupon_page',
              categoryId: 'platform',
              moduleId: 'platform_coupon_more',
              contentId: 'platform_coupon_more',
              exposureTimes: 1,
              businessInfo: {},
            });
          } else {
            this.morePages = [];
          }
          if (this.freeOneList.length > 0) {
            this.sendExpose(this.freeOneList);
          }
          if (this.freeTwoList.length > 0) {
            this.sendExpose(this.freeTwoList);
          }
        }
      } catch (ex) {
        Toast.showError(ex);
      }
    },
    getDistance(list, index, distance) {
      if (index < list.length - 1) {
        return `marginRight: ${distance}rem`;
      }
      return '';
    },
    getCurrentDistance(list, index) {
      if (list.length > 3) {
        return this.getDistance(list, index, 0.07);
      }
      return this.getDistance(list, index, 0.15);
    },
    isFloat(val) {
      const pureNum = parseFloat(String(val));
      if (String(pureNum).includes('.')) {
        return true;
      }
      return false;
    },
    beforeDiscount(val) {
      const value = parseFloat(String(val));
      if (String(value).includes('.')) {
        const before = String(value).split('.')[0];
        return before;
      }
      return value;
    },
    afterDiscount(val) {
      const value = parseFloat(String(val));
      const after = String(value).split('.')[1];
      return `.${after}`;
    },
    async getCoupon(item) {
      UBTUtils.clickButton({
        pageId: 'platform_Cross_coupon_page',
        buttonName: 'platform_free_coupon',
        categoryId: 'platform',
        businessInfo: {
          businessCode: item.businessCode,
          adsource: ParamsUtil.getParams(window.location.href).pageSrc,
          scenenumber: item.scene,
          batchCode: item.prizeCode,
          slotId: item.slotId, // 资源位
          creativeId: item.creativeId, // 创意ID
          media: item.media, // 广告门户业务线ID
          activity_id: item.activityCode,
        },
      });
      if (item.status === 1) {
        UBTUtils.clickButton({
          pageId: 'platform_Cross_coupon_page',
          buttonName: 'platform_free_coupon_get',
          categoryId: 'platform',
          businessInfo: {
            businessCode: item.businessCode,
            adsource: ParamsUtil.getParams(window.location.href).pageSrc,
            scenenumber: item.scene,
            batchCode: item.prizeCode,
            slotId: item.slotId, // 资源位
            creativeId: item.creativeId, // 创意ID
            media: item.media, // 广告门户业务线ID
            activity_id: item.activityCode,
          },
        });
        const data = await getTokenAndLocation();
        const {
          token, adCode, cityCode,
        } = data;
        const parmas = {
          token,
          activityCode: item.activityCode,
          packageCode: item.packageCode,
          prizeCode: item.prizeCode,
          adCode,
          cityCode,
          systemCode: getSystemCode(),
          version: await getVersion(),
        };
        try {
          const res = await prizeAward(parmas);
          if (res.code === 0) {
            Toast.show('领取成功');
            this.getColletList();
          }
        } catch (ex) {
          Toast.showError(ex);
        }
      } else {
        UBTUtils.clickButton({
          pageId: 'platform_Cross_coupon_page',
          buttonName: 'platform_free_coupon_use',
          categoryId: 'platform',
          businessInfo: {
            businessCode: item.businessCode,
            adsource: ParamsUtil.getParams(window.location.href).pageSrc,
            scenenumber: item.scene,
            batchCode: item.prizeCode,
            slotId: item.slotId, // 资源位
            creativeId: item.creativeId, // 创意ID
            media: item.media, // 广告门户业务线ID
            activity_id: item.activityCode,
          },
        });
        // commonGoLink(item.targetUrl, { isRuleLink: true });
        Native.openMarketingWeb({
          url: item.targetUrl,
        });
      }
    },
    goShare(item) {
      UBTUtils.clickButton({
        pageId: 'platform_Cross_coupon_page',
        buttonName: 'platform_coupon_share',
        categoryId: 'platform',
        businessInfo: {},
      });
      // commonGoLink(item.targetUrl, { isRuleLink: true });
      Native.openMarketingWeb({
        url: item.targetUrl,
      });
    },
    goLimitTime(item) {
      UBTUtils.clickButton({
        pageId: 'platform_Cross_coupon_page',
        buttonName: 'platform_coupon_Limit',
        categoryId: 'platform',
        businessInfo: {},
      });
      // commonGoLink(item.targetUrl, { isRuleLink: true });
      Native.openMarketingWeb({
        url: item.targetUrl,
      });
    },
    goPage(item) {
      UBTUtils.clickButton({
        pageId: 'platform_Cross_coupon_page',
        buttonName: 'platform_coupon_more',
        categoryId: 'platform',
        businessInfo: {},
      });
      // commonGoLink(item.targetUrl, { isRuleLink: true });
      Native.openMarketingWeb({
        url: item.targetUrl,
      });
    },
    sendExpose(list) {
      list.forEach((item) => {
        UBTUtils.moduleExpose({
          pageId: 'platform_Cross_coupon_page',
          categoryId: 'platform',
          moduleId: 'platform_free_coupon',
          contentId: 'platform_free_coupon',
          exposureTimes: 1,
          businessInfo: {
            businessCode: item.businessCode,
            adsource: ParamsUtil.getParams(window.location.href).pageSrc,
            scenenumber: item.scene,
            batchCode: item.prizeCode,
            slotId: item.slotId, // 资源位
            creativeId: item.creativeId, // 创意ID
            media: item.media, // 广告门户业务线ID
            activity_id: item.activityCode,
          },
        });
        if (item.status === 1) {
          UBTUtils.moduleExpose({
            pageId: 'platform_Cross_coupon_page',
            categoryId: 'platform',
            moduleId: 'platform_free_coupon_get',
            contentId: 'platform_free_coupon_get',
            exposureTimes: 1,
            businessInfo: {
              businessCode: item.businessCode,
              adsource: ParamsUtil.getParams(window.location.href).pageSrc,
              scenenumber: item.scene,
              batchCode: item.prizeCode,
              slotId: item.slotId, // 资源位
              creativeId: item.creativeId, // 创意ID
              media: item.media, // 广告门户业务线ID
              activity_id: item.activityCode,
            },
          });
        } else if (item.status === 2) {
          UBTUtils.moduleExpose({
            pageId: 'platform_Cross_coupon_page',
            categoryId: 'platform',
            moduleId: 'platform_free_coupon_use',
            contentId: 'platform_free_coupon_use',
            exposureTimes: 1,
            businessInfo: {
              businessCode: item.businessCode,
              adsource: ParamsUtil.getParams(window.location.href).pageSrc,
              scenenumber: item.scene,
              batchCode: item.prizeCode,
              slotId: item.slotId, // 资源位
              creativeId: item.creativeId, // 创意ID
              media: item.media, // 广告门户业务线ID
              activity_id: item.activityCode,
            },
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.collect-coupons-container {
  width: 100%;
  height: 100%;
  background-color: #edf0f2;

  .bkg {
    height: 2.77rem;
    background: url("https://m.hellobike.com/resource/helloyun/12399/HxOGFz7mFD.png") no-repeat top;
    background-size: 100% 100%;

    .safe-area {
      padding-top: constant(safe-area-inset-top);
      padding-top: env(safe-area-inset-top);
      height: 0.44rem;
    }

    .header {
      height: 0.45rem;
      line-height: 0.45rem;
      position: relative;
      text-align: center;

      .back {
        position: absolute;
        left: 0.18rem;
        top: 0.13rem;
        width: 0.1rem;
        height: 0.18rem;
        background: url("https://m.hellobike.com/resource/helloyun/12399/oNkhTISydk.png") no-repeat top;
        background-size: 100% 100%;
      }

      .title {
        font-size: 0.18rem;
        font-weight: 500;
        color: #242729;
      }
    }
  }

  .content {
    position: absolute;
    top: 1.73rem;
    padding: 0 0.1rem 0 0.14rem;
    width: 100vw;

    .free {
      border-radius: 0.12rem;
      background: #fff;
      padding: 0.17rem 0.12rem 0.18rem 0.12rem;
      margin-bottom: 0.1rem;

      .free-logo {
        display: flex;
        height: 0.24rem;
      }

      .scroll-container-one {
        display: flex;
        overflow-x: scroll;
        margin-top: 0.08rem;

        &::-webkit-scrollbar {
          display: none;
          width: 0;
          height: 0;
          color: transparent;
        }
      }

      .container-one {
        display: inline-flex;
        margin-top: 0.08rem;
      }

      .container-two {
        display: inline-flex;
        margin-top: 0.08rem;
      }

      .scroll-container-two {
        display: flex;
        overflow-x: scroll;
        margin-top: 0.08rem;

        &::-webkit-scrollbar {
          display: none;
          width: 0;
          height: 0;
          color: transparent;
        }
      }

      .instant-get {
        background: url("https://m.hellobike.com/resource/helloyun/12399/z0M49rABzC.png") no-repeat top;
        background-size: 100% 100%;
        width: 0.98rem;
        height: 1.21rem;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .go-use {
        background: url("https://m.hellobike.com/resource/helloyun/12399/x6PiZnIUia.png") no-repeat top;
        background-size: 100% 100%;
        width: 0.98rem;
        height: 1.21rem;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .business {
        display: inline-flex;
        margin-top: 0.05rem;

        .business-icon {
          height: 0.15rem;
          width: 0.15rem;
          margin-top: 0.01rem;
        }

        .business-name {
          margin-left: 0.01rem;
          font-size: 0.12rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #242729;
          line-height: 0.17rem;
        }
      }

      .business-content {
        display: inline-flex;
        margin-top: 0.03rem;

        .num-v1 {
          font-size: 0.28rem;
          font-family: DINAlternate-Bold, DINAlternate, sans-serif;
          font-weight: bold;
          color: #f72626;
          line-height: 0.32rem;
        }

        .num-v2 {
          display: inline-flex;

          .before {
            font-size: 0.28rem;
            font-family: DINAlternate-Bold, DINAlternate, sans-serif;
            font-weight: bold;
            color: #f72626;
            line-height: 0.32rem;
          }

          .after {
            font-size: 0.15rem;
            font-family: DINAlternate-Bold, DINAlternate, sans-serif;
            font-weight: bold;
            color: #f72626;
            line-height: 0.17rem;
            padding-top: 0.11rem;
          }
        }

        .unit {
          font-size: 0.12rem;
          font-family: PingFangSC-Semibold, PingFang SC, sans-serif;
          font-weight: 600;
          color: #f72626;
          line-height: 0.17rem;
          padding: 0.1rem 0 0 0.02rem;
        }
      }

      .rule {
        .info {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #879099;
          line-height: 17px;
        }
      }

      .free-btn {
        margin-top: 0.19rem;
        height: 0.22rem;
        width: 0.6rem;
      }
    }

    .share {
      border-radius: 0.12rem;
      background: #fff;
      padding: 0.17rem 0.12rem 0.08rem 0.12rem;
      margin-bottom: 0.1rem;

      .share-logo {
        height: 0.24rem;
      }

      .share-card {
        margin-top: 0.06rem;

        .share-coupon {
          height: 0.86rem;
          min-width: 3.27rem;
          background: #fff9f6;
          margin-bottom: 0.1rem;
        }
      }
    }

    .timeout {
      border-radius: 0.12rem;
      background: #fff;
      padding: 0.17rem 0.12rem 0.18rem 0.12rem;
      margin-bottom: 0.1rem;

      .timeout-logo {
        display: flex;
        height: 0.24rem;
      }

      .timeout-card {
        margin-top: 0.11rem;

        .timeout-item {
          display: inline-flex;

          .timeout-coupon {
            width: 1.6rem;
            height: 1.1rem;
            background: linear-gradient(316deg, #ffefe8 0%, #fff9f6 50%, #fff0e8 100%);
            border-radius: 0.08rem;
            margin-bottom: 0.02rem;
          }
        }
      }
    }

    .more {
      height: 1.51rem;
      border-radius: 0.12rem;
      background: #fff;
      padding: 0.17rem 0.12rem 0.18rem 0.12rem;
      margin-bottom: 0.1rem;

      .more-logo {
        height: 0.24rem;
      }

      .scroll-container {
        display: flex;
        overflow-x: scroll;
        margin-top: 0.1rem;

        &::-webkit-scrollbar {
          display: none;
          width: 0;
          height: 0;
          color: transparent;
        }
      }

      .more-stage {
        width: 1.29rem;
        height: 0.79rem;
      }
    }
  }
}
</style>
